import React from 'react';
import { BsCheck } from 'react-icons/bs';
import {
  FormStepsContainer,
  FormStepsContent,
  FormStepsStatus,
  FormStepsLabel,
  FormStepsCircle,
  FormStepsStatusBar
} from './styles';
import colors from '../../assets/styles/colors';

export const FormSteps = ({ lastStep, steps }) => {
  return (
    <FormStepsContainer>
      {steps.map((step, key) => (
        <FormStepsContent key={key}>
          <FormStepsStatus>
            <FormStepsLabel>{step.label}</FormStepsLabel>
            <FormStepsCircle active={lastStep === step.number - 1} finish={lastStep > step.number - 1}>
              {lastStep > step.number - 1 ? <BsCheck size={26} color={colors.white} id="check-icon" /> : step.number}
            </FormStepsCircle>
          </FormStepsStatus>
          {step.number < steps.length && <FormStepsStatusBar finish={lastStep > step.number - 1 } />}
        </FormStepsContent>
      ))}
    </FormStepsContainer>
  )
}

export default FormSteps;
